import type { FC } from "react";

import { faEllipsis } from "@fortawesome/pro-duotone-svg-icons/faEllipsis";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { MenuButton } from "./menu_button";

export const MenuButtonEllipsis: FC = () => (
  <MenuButton color="white" aria-label="More options">
    <FontAwesomeIcon icon={faEllipsis} />
  </MenuButton>
);
